document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.flickity-carousel');
  if (!carousel) {
    console.error('Flickity carousel not found in the DOM');
    return;
  }

  const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed, 10) || 5000;

  const flickityOptions = {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    autoPlay: autoplaySpeed,
    pauseAutoPlayOnHover: true,
    prevNextButtons: true,
    pageDots: false, // 33 videos = 33 dots; arrows + swipe are enough
    freeScroll: false,
    friction: 0.28,
    selectedAttraction: 0.025
  };

  const flkty = new Flickity(carousel, flickityOptions);

  // Show a video only while it is really playing; otherwise the poster <img>
  // underneath shows (iOS drops <video poster> after pause/rewind).
  carousel.querySelectorAll('.carousel-video').forEach(video => {
    video.addEventListener('playing', () => video.classList.add('is-playing'));
    ['pause', 'emptied', 'ended', 'error'].forEach(ev =>
      video.addEventListener(ev, () => video.classList.remove('is-playing')));
  });

  // Posters are loading="lazy", but off-centre slides sit far off to the side,
  // so the browser would defer them until they swipe in (grey box). Load the
  // selected slide and AHEAD neighbours each way as soon as the carousel is
  // near, then keep loading ahead on every change. All 33 at once was ~1.3 MB.
  const AHEAD = 3;
  const cells = flkty.cells.map(c => c.element);
  let postersWanted = false;
  function loadPostersAround(index) {
    const n = cells.length;
    for (let d = -AHEAD; d <= AHEAD; d++) {
      const img = cells[((index + d) % n + n) % n].querySelector('.carousel-poster');
      if (img && img.loading !== 'eager') img.loading = 'eager';
    }
  }
  if ('IntersectionObserver' in window) {
    const near = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) {
        postersWanted = true;
        loadPostersAround(flkty.selectedIndex);
        near.disconnect();
      }
    }, { rootMargin: '800px 0px' });
    near.observe(carousel);
  } else {
    postersWanted = true;
    loadPostersAround(flkty.selectedIndex);
  }
  flkty.on('select', (index) => { if (postersWanted) loadPostersAround(index); });

  let isCarouselInView = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isCarouselInView = entry.isIntersecting;
      if (isCarouselInView) {
        playCurrentVideo();
      } else {
        pauseAllVideos();
      }
    });
  }, {
    threshold: 0.5
  });

  observer.observe(carousel);

  flkty.on('ready', function() {
    if (isCarouselInView) {
      playCurrentVideo();
    }
  });

  flkty.on('change', function() {
    if (isCarouselInView) {
      playCurrentVideo();
    }
  });

  function pauseAllVideos() {
    const videos = document.querySelectorAll('.carousel-video');
    videos.forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }

  function playCurrentVideo() {
    if (!isCarouselInView) {
      return;
    }
    const videos = document.querySelectorAll('.carousel-video');
    if (!videos.length) {
      console.error('No carousel videos found in the DOM');
      return;
    }

    videos.forEach(video => {
      video.loop = false;
      video.pause();
      video.currentTime = 0;
    });

    const currentCell = flkty.selectedElement;
    if (!currentCell) {
      console.error('No selected cell found in Flickity');
      return;
    }

    const video = currentCell.querySelector('.carousel-video');
    if (!video) {
      console.error('No video found in the selected cell');
      return;
    }

    const playVideo = () => {
      video.loop = true;
      video.play().catch(error => {
        console.error('Video playback failed:', error.message);
      });
    };

    video.load();
    if (video.readyState >= 2) {
      playVideo();
    } else {
      video.addEventListener('canplay', playVideo, { once: true });
      video.addEventListener('error', () => {
        console.error('Video loading failed:', video.querySelector('source').src);
      }, { once: true });
    }
  }

  const lightbox = document.getElementById('video-lightbox');
  if (!lightbox) {
    console.error('Video lightbox not found in the DOM');
    return;
  }

  const lightboxVideo = lightbox.querySelector('.lightbox-video');
  const lightboxSource = lightboxVideo.querySelector('source');
  const closeButton = lightbox.querySelector('.lightbox-close');

  function openLightbox(videoUrl) {
    pauseAllVideos();
    lightboxSource.setAttribute('src', videoUrl);
    lightboxVideo.load();
    lightbox.style.display = 'flex';
    lightboxVideo.play().catch(error => console.error('Lightbox video play failed:', error));
    flkty.pausePlayer();
  }

  function closeLightbox() {
    lightbox.style.display = 'none';
    lightboxVideo.pause();
    flkty.playPlayer();
    playCurrentVideo();
  }

  document.querySelectorAll('.carousel-video').forEach(video => {
    video.addEventListener('click', function() {
      const videoWrapper = this.closest('.video-wrapper');
      const videoUrl = videoWrapper.getAttribute('data-video-url');
      if (videoUrl) {
        openLightbox(videoUrl);
      }
    });
  });

  document.querySelectorAll('.play-icon').forEach(icon => {
    icon.addEventListener('click', function() {
      const videoWrapper = this.closest('.video-wrapper');
      const videoUrl = videoWrapper.getAttribute('data-video-url');
      if (videoUrl) {
        openLightbox(videoUrl);
      }
    });
  });

  closeButton.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });
});
